<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="90px" :rules="rules">
      <el-form-item label="报警次数:">{{rowData.warning ? rowData.warning.warning_count : 0}} 次</el-form-item>
      <el-form-item label="报警描述:">{{rowData.warning ? rowData.warning.warning_desp : ''}}</el-form-item>
      <el-form-item label="处理详情:" prop="task_desp">
        <el-input v-model="ruleForm.task_desp" type="textarea" rows="7" maxlength="250" show-word-limit />
      </el-form-item>
      <el-form-item label="附件:">
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="uploadAction"
          :data="uploadParams"
          :name="fileName"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :on-success="handleSuccess"
          :file-list="fileList">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <div slot="tip" class="el-upload__tip">*单个文件大小最大支持200M</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
// import GlobalData from '@/api/global_data'
import md5 from 'js-md5'
const reader = new FileReader()

export default {
  name: '',
  data () {
    const taskId = this.rowData.task_id
    return {
      uploadAction: Backend.BACKENDURL + '/admin/task_addition_file/task_addition_file_upload',
      uploadParams: {
        task_id: taskId,
        file_name: '',
        md5: ''
      },
      fileName: '',
      fileList: [],
      removeFileList: [],
      ruleForm: {
        task_id: taskId,
        task_desp: ''
      },
      rules: {
        task_desp: [
          { required: true, message: '请输入处理详情', trigger: 'blur' }
        ]
      }
    }
  },

  props: ['rowData'],

  created () {
    reader.addEventListener('load', this.md5Made)
  },

  destroyed () {
    reader.removeEventListener('load', this.md5Made)
  },

  methods: {
    md5Made (e) {
      console.log(e)
      var res = e.target.result
      this.uploadParams.md5 = md5(res)
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
      this.fileList = fileList
      const i = this.removeFileList.findIndex(name => name === file.name)
      if (i < 0) this.removeFileList.push(file.name)
    },
    handleSuccess (res, file, fileList) {
      if (res.success) {
        console.log(res, file, fileList, this.fileList)
        this.fileList = fileList
        const i = this.removeFileList.findIndex(name => name === file.name)
        if (i >= 0) this.removeFileList.splice(i, 1)
      } else {
        this.$message.error(res.message)
        this.$refs.upload.clearFiles()
      }
    },
    beforeUpload (file) {
      if (file.name.length > 100) {
        this.$message.error('文件名不能超过100个字符!')
        return false
      }

      const i = this.fileList.findIndex(it => it.name === file.name)
      if (i >= 0) {
        this.$message.error('已经存在相同文件!')
        return false
      }

      if (file.size / 1024 / 1024 > 200) {
        this.$message.error('单个文件大小不能超过200M!')
        return false
      }

      let timer = null
      this.uploadParams.file_name = file.name
      this.fileName = file.name

      reader.readAsArrayBuffer(file)

      return new Promise(resolve => {
        timer = setInterval(() => {
          console.log(3)
          if (this.uploadParams.md5) {
            clearInterval(timer)
            resolve()
          }
        }, 300)
      })
    },
    resetForm () {
      this.share.head_image = this.ruleForm.head_image_url
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.ruleForm)
          params.file_to_add = JSON.stringify(this.fileList.map(it => it.response.data))
          params.file_to_delete = JSON.stringify(this.removeFileList)

          Backend.post(this, '/task/task_save', params).then((data) => {
            this.$message.success('提交成功!')
            this.$emit('tableCloseDialog')
            this.rowData.task_status = data.task_status
            this.rowData.task_status_desp = data.task_status_desp
            // const pageData = GlobalData.tabShareData['任务列表'].pageData
            // if (pageData) {
            //   const src = pageData.items.find(it => it.task_id === this.rowData.task_id)
            //   Backend.copyObject(data, undefined, src)
            // }
          })
        }
      })
    }
  }
}
</script>
